<template>
  <div class="app-container">
    <div class="filter-container">
         <el-button
        class="filter-item"
        type="warning"
        @click="$router.go(-1)"
        style="float: right"
        >返回</el-button
      >
      <el-button class="filter-item" type="primary" @click="randomWin"
        >手机随机抽奖</el-button
      >
      <!-- <el-button class="filter-item" type="primary" @click="handleCreate('')"
        >新增</el-button
      >
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_on"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>
      <el-select
        v-model="listQuery.type"
        placeholder="商品类型"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="普通抢购商品" :value="1" />
        <el-option label="预约抢购商品" :value="2" />
        <el-option label="优先抢购商品" :value="3" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter">
        搜索
      </el-button> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1" type="primary"
            >普通抢购商品</el-tag
          >
          <el-tag v-else-if="scope.row.type == 2" type="success"
            >预约抢购商品</el-tag
          >
          <el-tag v-else type="warning">优先抢购商品</el-tag>
        </template>
      </el-table-column> -->

    
      <el-table-column label="用户头像" min-width="110"  align="center">
        <template slot-scope="scope">
          <el-image
            class="image-url-150"
            style="width: 130px; height: 130px"
            :src="scope.row.user?scope.row.user.avatar:'#'"
            lazy
            :preview-src-list="[scope.row.user.avatar]"
          ></el-image>
        </template>
      </el-table-column>
        <el-table-column label="用户昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?scope.row.user.nickname:"-" }}
        </template>
      </el-table-column>
      
      <el-table-column label="是否中签" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_win == 1" type="success">是</el-tag>
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="申请时间" min-width="110" align="center">
         <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      

      <!-- <el-table-column label="砍价人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.bargain_num }}
        </template>
      </el-table-column> -->

      <!-- <el-table-column
        label="操作"
        width="280"
        align="center"
        class-name=" fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleCreate(scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            >下架</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            >上架</el-button
          >
          <el-button
            size="mini"
            type="success"
            v-if="scope.row.handle_status==0"
            @click="issue(scope.row.id)"
          >
            发行
          </el-button>

        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        title: "",
        is_on: "",
        is_index_show: "",
        product_id:''
      },
      btnLoading: false,
    };
  },
  created() {
    this.listQuery.product_id=this.$route.query.id
    this.getList();
  },
  methods: {
    participation(row, type) {
      // let data= JSON.stringify(row)
      if (type == 1) {
        this.$router.push(`/product/participation_pt?data=${row.id}`);
      } else {
        this.$router.push(`/product/participation_kj?data=${row.id}`);
      }
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/reservedApplyLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate(row) {
      this.$router.push(`/product/list_edit?id=${row.id}`);
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该课程类型, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/upDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    randomWin() {
      this.$confirm("此操作将随机中签, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/randomWin",
            method: "post",
            data: { product_id: this.listQuery.product_id },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //删除
    handleShow(val, text) {
      this.$confirm("此操作将课程类型" + text + ", 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/course/categoryIndexShow",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //发行
    issue(val) {
      this.$confirm("此操作将发行该产品, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/issue",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
